import distance from '@turf/distance';
import { point } from '@turf/helpers';
import { format, isBefore, parse } from 'date-fns';
import { formatDate, parseDate } from '../../../utils/date';
const weekdays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
const getStoreWorkTimeFromByDay = (store, day) => {
    return store[`workTime${day}From`];
};
const getStoreWorkTimeTillByDay = (store, day) => {
    return store[`workTime${day}Till`];
};
const getStoreWorkTimeAllDayByDay = (store, day) => {
    return store[`workTime${day}AllDay`];
};
export const getStoreWorkTimes = (store) => weekdays.slice(1).reduce((workTimes, day) => {
    const lastWorkTime = workTimes[workTimes.length - 1];
    const timeFrom = getStoreWorkTimeFromByDay(store, day);
    const timeTill = getStoreWorkTimeTillByDay(store, day);
    const allDay = getStoreWorkTimeAllDayByDay(store, day);
    if (lastWorkTime.timeFrom === timeFrom && lastWorkTime.timeTill === timeTill && lastWorkTime.allDay === allDay) {
        return [...workTimes.slice(0, -1), { ...lastWorkTime, dayTill: day }];
    }
    return [...workTimes, { dayFrom: day, dayTill: day, timeFrom, timeTill, allDay }];
}, [
    {
        dayFrom: weekdays[0],
        dayTill: weekdays[0],
        timeFrom: getStoreWorkTimeFromByDay(store, weekdays[0]),
        timeTill: getStoreWorkTimeTillByDay(store, weekdays[0]),
        allDay: getStoreWorkTimeAllDayByDay(store, weekdays[0]),
    },
]);
export const getTranslatableStoreOpenStatus = (store, date) => {
    const day = format(date, 'EEE');
    const allDay = getStoreWorkTimeAllDayByDay(store, day);
    if (allDay) {
        return { key: 'store_locator.details.open_all_day' };
    }
    const openFrom = getStoreWorkTimeFromByDay(store, day);
    const openTill = getStoreWorkTimeTillByDay(store, day);
    if (openFrom && openTill) {
        const openFromDate = parse(openFrom, 'HH:mm:ss', date);
        const openTillDate = parse(openTill, 'HH:mm:ss', date);
        if (isBefore(date, openFromDate)) {
            return {
                key: 'store_locator.details.opens_at_time',
                parameters: { time: formatDate(openFromDate, 'HH:mm') },
            };
        }
        if (isBefore(date, openTillDate)) {
            return {
                key: 'store_locator.details.open_until_time',
                parameters: { time: formatDate(openTillDate, 'HH:mm') },
            };
        }
    }
    const dayIndex = weekdays.indexOf(day);
    const weekdaysFromDay = [...weekdays.slice(dayIndex + 1), ...weekdays.slice(0, dayIndex + 1)];
    const nextDay = weekdaysFromDay.find(weekday => (getStoreWorkTimeFromByDay(store, weekday) && getStoreWorkTimeTillByDay(store, weekday)) ||
        getStoreWorkTimeAllDayByDay(store, weekday));
    return nextDay
        ? {
            key: 'store_locator.details.opens_on_day',
            parameters: { day: formatDate(parseDate(nextDay, 'EEE'), 'EEEE') },
        }
        : null;
};
export const isStoreOpen = (store, date) => {
    const day = format(date, 'EEE');
    const allDay = getStoreWorkTimeAllDayByDay(store, day);
    if (allDay) {
        return true;
    }
    const openFrom = getStoreWorkTimeFromByDay(store, day);
    const openTill = getStoreWorkTimeTillByDay(store, day);
    if (openFrom && openTill) {
        const openFromDate = parse(openFrom, 'HH:mm:ss', date);
        const openTillDate = parse(openTill, 'HH:mm:ss', date);
        return !isBefore(date, openFromDate) && isBefore(date, openTillDate);
    }
    return false;
};
export const getStoreDistanceToPosition = (store, position) => distance(point([position.coords.longitude, position.coords.latitude]), point([store.longitude, store.latitude]), 'kilometers');
